// extracted by mini-css-extract-plugin
export var activeFilterButton = "_my-c";
export var backButton = "_my-4";
export var backIcon = "_my-5";
export var chevronShortcut = "_my-6";
export var container = "_my-1";
export var editor = "_my-8";
export var editorWrapper = "_my-7";
export var prefix = "_my-2";
export var searchIcon = "_my-3";
export var suffix = "_my-9";
export var suffixContent = "_my-a";
export var suffixText = "_my-b";
export var wrapper = "_my-0";